var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from 'react';
import { Box, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import CheckIcon from '@mui/icons-material/Check';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { formatCurrency } from '../../utils/commonUtilities';
import CommonTable from '../../components/commonTableComponent/CommonTable';
import CustomerTypeIcon from './components/CustomerTypeIcon';
import { BacklogHoverTooltip, BacklogStatusBadge, BacklogTypeBadge } from './components/BacklogBadges';
import useContractStatusHistoryPopup from './components/useContractStatusHistoryPopup';
import { FundingLogHistoryIcon } from './fundingLog/FundingLogStatusHistoryPopup';
import { DealerCallIcon } from '../../components/icons';
import { toBacklogRowViewModel } from './components/backlogRowMapper';
import { baseColors } from '../../Themes/colors';
import { ApplicationManagementEnum } from '../../config/TableColumns';
import constants from '../../config/constants';
import { utility } from '../../utils';
import { api_service } from '../../api/api_service';
import { api_urls } from '../../api/api_urls';
var IMPERSONATE_COLOR = '#00897B';
var successPreset = baseColors.successPreset, bluePreset = baseColors.bluePreset;
var copyTextSafely = function (value) { return __awaiter(void 0, void 0, void 0, function () {
    var error_1, textArea, copied;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 3, , 4]);
                if (!((_a = navigator === null || navigator === void 0 ? void 0 : navigator.clipboard) === null || _a === void 0 ? void 0 : _a.writeText)) return [3, 2];
                return [4, navigator.clipboard.writeText(value)];
            case 1:
                _b.sent();
                return [2, true];
            case 2: return [3, 4];
            case 3:
                error_1 = _b.sent();
                return [3, 4];
            case 4:
                try {
                    textArea = document.createElement('textarea');
                    textArea.value = value;
                    textArea.style.position = 'fixed';
                    textArea.style.left = '-9999px';
                    textArea.style.top = '0';
                    document.body.appendChild(textArea);
                    textArea.focus();
                    textArea.select();
                    copied = document.execCommand('copy');
                    document.body.removeChild(textArea);
                    return [2, copied];
                }
                catch (error) {
                    return [2, false];
                }
                return [2];
        }
    });
}); };
var CopyButton = function (_a) {
    var value = _a.value, label = _a.label, copyKey = _a.copyKey, activeCopyKey = _a.activeCopyKey, onCopied = _a.onCopied;
    var isCopied = activeCopyKey === copyKey;
    var handleCopy = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var copied, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.preventDefault();
                    event.stopPropagation();
                    if (!value)
                        return [2];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, copyTextSafely(value)];
                case 2:
                    copied = _a.sent();
                    if (!copied) {
                        return [2];
                    }
                    onCopied(copyKey);
                    return [3, 4];
                case 3:
                    error_2 = _a.sent();
                    console.error('Copy failed:', error_2);
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); };
    return (React.createElement(Tooltip, { title: isCopied ? 'Copied' : "Copy ".concat(label) },
        React.createElement(IconButton, { size: "small", "aria-label": isCopied ? 'Copied' : "Copy ".concat(label), onClick: handleCopy, sx: { color: baseColors.fullWhite, p: 0.25 } }, isCopied ? (React.createElement(CheckIcon, { sx: { fontSize: 16, color: successPreset[30] } })) : (React.createElement(ContentCopyOutlinedIcon, { sx: { fontSize: 16 } })))));
};
var DealerSalesRepTooltipContent = function (_a) {
    var name = _a.name, phone = _a.phone, email = _a.email;
    var _b = useState(null), activeCopyKey = _b[0], setActiveCopyKey = _b[1];
    var handleCopied = React.useCallback(function (key) {
        setActiveCopyKey(null);
        requestAnimationFrame(function () { return setActiveCopyKey(key); });
    }, []);
    React.useEffect(function () {
        if (!activeCopyKey)
            return;
        var timer = setTimeout(function () {
            setActiveCopyKey(null);
        }, 1500);
        return function () { return clearTimeout(timer); };
    }, [activeCopyKey]);
    return (React.createElement(Box, { sx: { display: 'flex', flexDirection: 'column', gap: 1.25 } },
        React.createElement(Typography, { sx: {
                fontSize: 20,
                lineHeight: '28px',
                color: baseColors.fullWhite,
            } }, name),
        React.createElement(Box, { sx: { display: 'inline-flex', alignItems: 'center', gap: 1 } },
            React.createElement(Typography, { sx: {
                    fontSize: 11,
                    lineHeight: '16px',
                    color: baseColors.fullWhite,
                } },
                "Mobile: ",
                phone || '--'),
            React.createElement(CopyButton, { value: phone, label: "Mobile", copyKey: "phone", activeCopyKey: activeCopyKey, onCopied: handleCopied })),
        React.createElement(Box, { sx: { display: 'inline-flex', alignItems: 'center', gap: 1 } },
            React.createElement(Typography, { sx: {
                    fontSize: 11,
                    lineHeight: '16px',
                    color: baseColors.fullWhite,
                } },
                "Email: ",
                email || '--'),
            React.createElement(CopyButton, { value: email, label: "Email", copyKey: "email", activeCopyKey: activeCopyKey, onCopied: handleCopied }))));
};
var ImpersonateIconButton = function (_a) {
    var accountAspireId = _a.accountAspireId, accountAspireOId = _a.accountAspireOId;
    var _b = useState(false), isImpersonating = _b[0], setIsImpersonating = _b[1];
    var handleImpersonate = function (e) {
        e.stopPropagation();
        if (isImpersonating || (!accountAspireId && !accountAspireOId)) {
            return;
        }
        setIsImpersonating(true);
        var payload = accountAspireId
            ? { AccountAspireId: accountAspireId }
            : { AccountAspireOId: accountAspireOId };
        api_service.get({
            endPoint: api_urls.ADMIN_IMPERSONATE,
            payLoad: payload,
            showLoader: true,
        }).then(function (res) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            setIsImpersonating(false);
            if (res && res.data.statusCode === 200) {
                var vendorDomain = (_a = res.data.data) === null || _a === void 0 ? void 0 : _a.Domain;
                var url = "".concat(vendorDomain, "/adminDashboard?token=").concat(encodeURIComponent((_c = (_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.Token), "&roleType=").concat((_e = (_d = res === null || res === void 0 ? void 0 : res.data) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.RoleType, "&roleApproval=").concat((_g = (_f = res === null || res === void 0 ? void 0 : res.data) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.RoleApproval, "&sessionStartTime=").concat((_j = (_h = res === null || res === void 0 ? void 0 : res.data) === null || _h === void 0 ? void 0 : _h.data) === null || _j === void 0 ? void 0 : _j.SessionStartTime);
                window.open(url, '_blank');
            }
            else {
                utility.alert(res.data.message, constants.TOAST_TYPES.ERROR);
            }
        }).catch(function (err) {
            setIsImpersonating(false);
            utility.alert(err, constants.TOAST_TYPES.ERROR);
        });
    };
    return (React.createElement(Tooltip, { title: "Impersonate" },
        React.createElement("span", null,
            React.createElement(IconButton, { size: "small", disabled: isImpersonating, onClick: handleImpersonate, sx: {
                    p: 0.25,
                    color: IMPERSONATE_COLOR,
                    '&:hover': { backgroundColor: "".concat(IMPERSONATE_COLOR, "14") },
                    '&.Mui-disabled': { color: baseColors.greyPreset[20] },
                } },
                React.createElement(OpenInNewIcon, { sx: { fontSize: 16 } })))));
};
var DealerSalesRepCell = function (_a) {
    var value = _a.value, row = _a.row;
    var TOOLTIP_OPEN_DELAY_MS = 300;
    var TOOLTIP_CLOSE_DELAY_MS = 320;
    var openTimerRef = React.useRef(null);
    var closeTimerRef = React.useRef(null);
    var _b = useState(false), tooltipOpen = _b[0], setTooltipOpen = _b[1];
    var clearOpenTimer = React.useCallback(function () {
        if (openTimerRef.current) {
            window.clearTimeout(openTimerRef.current);
            openTimerRef.current = null;
        }
    }, []);
    var clearCloseTimer = React.useCallback(function () {
        if (closeTimerRef.current) {
            window.clearTimeout(closeTimerRef.current);
            closeTimerRef.current = null;
        }
    }, []);
    var handleOpenTooltip = React.useCallback(function () {
        clearCloseTimer();
        clearOpenTimer();
        openTimerRef.current = window.setTimeout(function () {
            setTooltipOpen(true);
            openTimerRef.current = null;
        }, TOOLTIP_OPEN_DELAY_MS);
    }, [clearCloseTimer, clearOpenTimer]);
    var handleCloseTooltip = React.useCallback(function () {
        clearOpenTimer();
        clearCloseTimer();
        closeTimerRef.current = window.setTimeout(function () {
            setTooltipOpen(false);
            closeTimerRef.current = null;
        }, TOOLTIP_CLOSE_DELAY_MS);
    }, [clearCloseTimer, clearOpenTimer]);
    React.useEffect(function () {
        return function () {
            clearOpenTimer();
            clearCloseTimer();
        };
    }, [clearCloseTimer, clearOpenTimer]);
    var content = (React.createElement(Box, { sx: { display: 'inline-flex', alignItems: 'center', gap: 1.25 } },
        React.createElement(Typography, { variant: 'caption' }, value || '—'),
        value ? (React.createElement(Box, { sx: { display: 'inline-flex', alignItems: 'center', gap: 1 } },
            React.createElement(DealerCallIcon, null),
            React.createElement(MailOutlineIcon, { sx: { color: successPreset[30], fontSize: 16 } }))) : null));
    var impersonateIcon = null;
    if (!value) {
        return content;
    }
    return (React.createElement(Box, { sx: { display: 'inline-flex', alignItems: 'center', gap: 1 } },
        React.createElement(Box, { component: "span", onClick: function (e) { return e.stopPropagation(); }, onMouseEnter: handleOpenTooltip, onMouseLeave: handleCloseTooltip, sx: { display: 'inline-flex' } },
            React.createElement(BacklogHoverTooltip, { open: tooltipOpen, disableFocusListener: true, disableTouchListener: true, onOpen: handleOpenTooltip, onClose: handleCloseTooltip, title: (React.createElement(Box, { onClick: function (e) { return e.stopPropagation(); }, onMouseEnter: handleOpenTooltip, onMouseLeave: handleCloseTooltip },
                    React.createElement(DealerSalesRepTooltipContent, { name: value, phone: row.dealerSalesRepPhone, email: row.dealerSalesRepEmail }))) }, content)),
        impersonateIcon));
};
export var allBacklogColumns = [
    {
        key: 'contractId',
        header: 'Contract ID',
        sortKey: ApplicationManagementEnum.ContractID,
        sortable: true,
        render: function (value) { return (React.createElement(Typography, { variant: 'subtitle2', sx: { color: successPreset[30] } }, value || '—')); },
    },
    {
        key: 'transaction',
        header: 'Transaction ID',
        render: function (value) { return (React.createElement(Typography, { variant: 'caption' }, value || '—')); },
    },
    {
        key: 'customerName',
        header: 'Customer',
        render: function (value, row) { return (React.createElement(Stack, { direction: "row", alignItems: "center", justifyContent: "flex-start", gap: 0.75, sx: { minWidth: 0, width: '100%' } },
            React.createElement(CustomerTypeIcon, { type: row === null || row === void 0 ? void 0 : row.customerType }),
            React.createElement(Typography, { variant: 'caption' }, value || '—'))); },
    },
    {
        key: 'dealerName',
        header: 'Dealer Name',
        render: function (value) { return (React.createElement(Typography, { variant: 'caption' }, value || '—')); },
    },
    {
        key: 'programName',
        header: 'Program Name',
        render: function (value) { return (React.createElement(Typography, { variant: 'caption' }, value || '—')); },
    },
    {
        key: 'status',
        header: 'Status',
        sortKey: ApplicationManagementEnum.Status,
        sortable: false,
        render: function (value) { return React.createElement(BacklogStatusBadge, { value: value }); },
    },
    {
        key: 'statusDate',
        header: 'Status Update Date',
        render: function (value) { return (React.createElement(Typography, { variant: 'caption' }, value || '—')); },
    },
    {
        key: 'dealerSalesRepName',
        header: 'Dealer Sales Rep',
        render: function (value, row) { return React.createElement(DealerSalesRepCell, { value: value, row: row }); },
    },
    {
        key: 'applicationDate',
        header: 'Application Date',
        sortKey: ApplicationManagementEnum.CreatedTime,
        sortable: true,
        render: function (value) { return (React.createElement(Typography, { variant: 'caption' }, value || '—')); },
    },
    {
        key: 'forecastDate',
        header: 'Forecast Date',
        render: function (value) { return (React.createElement(Typography, { variant: 'caption' }, value || '—')); },
    },
    {
        key: 'submittedBy',
        header: 'Submission Type',
        render: function (value) { return (React.createElement(Typography, { variant: 'caption' }, value || '—')); },
    },
    {
        key: 'type',
        header: 'Type',
        render: function (value) { return React.createElement(BacklogTypeBadge, { value: value }); },
    },
    {
        key: 'amount',
        header: 'Amount Financed',
        render: function (value) { return (React.createElement(Typography, { variant: 'subtitle2' }, value ? formatCurrency(value) : '—')); },
    },
];
export var FIXED_COLUMN_KEYS = ['contractId', 'customerName', 'status'];
export var defaultVisibleColumnKeys = [
    'contractId',
    'customerName',
    'dealerName',
    'programName',
    'status',
    'statusDate',
    'dealerSalesRepName',
    'applicationDate',
    'forecastDate',
    'submittedBy',
    'amount',
    'type',
];
var BacklogTableSection = React.memo(function (_a) {
    var backlogAppList = _a.backlogAppList, isFetching = _a.isFetching, currentPage = _a.currentPage, perPageCount = _a.perPageCount, setCurrentPage = _a.setCurrentPage, setPerPageCount = _a.setPerPageCount, totalCount = _a.totalCount, handleApplicatonClick = _a.handleApplicatonClick, sortBy = _a.sortBy, _b = _a.sortOrder, sortOrder = _b === void 0 ? 'ASC' : _b, handleSortChange = _a.handleSortChange, visibleColumnKeys = _a.visibleColumnKeys;
    var _c = useContractStatusHistoryPopup(), openHistory = _c.openHistory, historyPopup = _c.historyPopup;
    var columns = React.useMemo(function () {
        var baseColumns = visibleColumnKeys
            ? allBacklogColumns.filter(function (col) { return FIXED_COLUMN_KEYS.includes(col.key) || visibleColumnKeys.includes(col.key); })
            : allBacklogColumns;
        return baseColumns.map(function (col) { return (col.key === 'status' ? __assign(__assign({}, col), { render: function (value, row) { return (React.createElement(Stack, { direction: "row", alignItems: "center", gap: 0.75, sx: { minWidth: 0 } },
                React.createElement(BacklogStatusBadge, { value: value }),
                React.createElement(Tooltip, { title: "Contract Status History", arrow: true, placement: "top" },
                    React.createElement(Box, { component: "span", role: "button", tabIndex: 0, onClick: function (event) { var _a; event.stopPropagation(); openHistory((_a = row === null || row === void 0 ? void 0 : row._original) === null || _a === void 0 ? void 0 : _a.TxAspireOId); }, onKeyDown: function (event) {
                            var _a;
                            if (event.key === 'Enter' || event.key === ' ') {
                                event.preventDefault();
                                event.stopPropagation();
                                openHistory((_a = row === null || row === void 0 ? void 0 : row._original) === null || _a === void 0 ? void 0 : _a.TxAspireOId);
                            }
                        }, sx: { display: 'inline-flex', alignItems: 'center', cursor: 'pointer', flexShrink: 0, '&:hover': { opacity: 0.85 } } },
                        React.createElement(FundingLogHistoryIcon, null))))); } }) : col); });
    }, [visibleColumnKeys, openHistory]);
    var mappedData = React.useMemo(function () {
        var _a;
        return (_a = backlogAppList === null || backlogAppList === void 0 ? void 0 : backlogAppList.map(function (item) { return (__assign(__assign({}, toBacklogRowViewModel(item)), { _original: item })); })) !== null && _a !== void 0 ? _a : [];
    }, [backlogAppList]);
    return (React.createElement(React.Fragment, null,
        React.createElement(CommonTable, { columns: columns, data: mappedData, loading: isFetching, onRowClick: function (row) { return handleApplicatonClick(row._original); }, keyExtractor: function (row, index) { var _a; return (_a = row.contractId) !== null && _a !== void 0 ? _a : index; }, onSortChange: handleSortChange ? function (nextSortBy, nextSortDir) {
                handleSortChange(nextSortBy, nextSortDir === 'desc' ? 'DESC' : 'ASC');
            } : undefined, currentSortKey: sortBy !== null && sortBy !== void 0 ? sortBy : null, currentSortDir: sortOrder === 'DESC' ? 'desc' : 'asc', "aria-label": "Backlog Applications Table", "data-testid": "backlog-table-section", stickyHeader: true, height: "100%", moduleName: "Application Management" }),
        historyPopup));
});
export default BacklogTableSection;
